import { IResult } from '../../store/slices/search';
import api from '../instance';

interface ISearchResultsParams {
  q: string;
  per_page: number;
  scopes: string;
  page: number;
}

type TSearchResultsCountResponse = {
  total: number;
  type: string;
}[];

type TSearchResultsResponse = IResult[];

export default {
  getSearchResultsCount: (searchValue: string): Promise<TSearchResultsCountResponse> =>
    api.get(`/search/count?${new URLSearchParams({ q: searchValue })}`),
  searchResults: (params: ISearchResultsParams): Promise<TSearchResultsResponse> =>
    api.get(
      `search?${new URLSearchParams({
        ...params,
        per_page: params.per_page.toString(),
        page: params.page.toString(),
      })}`,
    ),
};
